import type { Components, CssVarsTheme } from '@mui/material/styles';
import { toolbarHeight, toolbarHeightDense } from '../../../constants/toolbar';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiToolbar']
>['styleOverrides'] = {
  root: ({ ownerState, theme }) => ({
    height: ownerState.variant === 'dense' ? toolbarHeightDense : toolbarHeight,
    [theme.breakpoints.down('lg')]: {
      minHeight: 'unset',
      height: toolbarHeightDense,
    },
  }),
};

const MuiToolbar: Components<CssVarsTheme>['MuiToolbar'] = {
  styleOverrides,
};

export default MuiToolbar;
